import { ResourceCard } from "@components/cards/ResourceCard"
import { StaggerTransitionRoot } from "@components/motion/Transition"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Resources Listing Page",
}

export default defineView("template-resource-listing", (props) => {
  return (
    <StaggerTransitionRoot>
      <ContentBlocks blocks={props.page?.contentBlocks} />
      <div className="w-grid mx-auto">
        <div data-transition="fade">
          <div className="type-title-l-medium pb-3 mb-5 mt-6">Resource Library</div>
        </div>
        {props.resources?.nodes.map((resource) => {
          return (
            <div data-transition="fade" key={resource.uri}>
              <ResourceCard {...resource} />
            </div>
          )
        })}
        <div className="h-10" />
      </div>
    </StaggerTransitionRoot>
  )
})
